import {
  APIAllInstallationsCDL,
  APIAllInstallationsMarket,
  APIAllInstallationsProduct,
  APIAllInstallationsUF,
  APIAllInstallationsVendor,
} from "../core/contracts/AllInstallationsFilter";
import { AllInstallationsFilterGet } from "../core/models/AllInstallationsFilter";
import { SessionCache } from "../helpers/cache";
import BaseService from "./BaseService";

export default class FilterService {
  async fetchAllInstallationsFilter() {
    try {
      const storage = new SessionCache();
      // product filter
      const possibleProducts: APIAllInstallationsProduct[] = await new BaseService(false).get(
        "/product"
      );

      const possibleUFs: APIAllInstallationsUF[] = await new BaseService(false).get("/uf");

      const possibleVendors: APIAllInstallationsVendor[] = await new BaseService(false).get(
        "/vendor"
      );

      storage.set("vendor", possibleVendors);

      const responsibleCDL: APIAllInstallationsCDL[] = await new BaseService(false).get(
        "/responsible_ldc"
      );

      const marketSegmentation: APIAllInstallationsMarket[] = await new BaseService(false).get(
        "/market_segmentation"
      );

      const result: AllInstallationsFilterGet = {
        installation_product: possibleProducts?.map((x) => x.installation_product_code ?? "") ?? [],
        installation_uf: possibleUFs?.map((x) => x.uf_customer ?? "")?.filter((x) => x) ?? [],
        installation_vendor: possibleVendors?.map((x) => x.rtu_vendor ?? "") ?? [],
        installation_cdl: responsibleCDL?.map((x) => x.responsible_ldc ?? "") ?? [],
        installation_market: marketSegmentation?.map((x) => x.market_segmentation ?? "") ?? [],
      };

      return result;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("🚀 ~ file: FilterService.ts ~ line 12 ~ FilterService ~ fetch ~ error", error);
      return Promise.reject("Unable to resolve filters promises!");
    }
  }
}
